import { helpers, elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { close } from '#utilities/js/lightboxes/menus/menu.js'

const params = new WeakMap()

const onClick = object(listener, {
  type: click,
  passive,
  task: async (
    button
  ) => {
    const { value, ownerDocument } = button
    const modal = one(`.${elements.modal}`, ownerDocument)
    const canvas = one(`.${helpers.xfiles.elements.xfiles_attach_draw_canvas}`, modal)
    const context = canvas.getContext('2d')
    const dataURL = canvas.toDataURL()
    let { width, height } = canvas
    let image = await new Image()

    if (context) {
      if (!params.has(image)) {
        params.set(image, object(null, { context, width, height, value }))
      }

      onLoad.listen(image)
      image.src = dataURL
    }

    close()
  }
})

const onLoad = object(listener, {
  type: load,
  once,
  passive,
  task: async (
    image
  ) => {
    const { context, width, height, value } = params.get(image)
    let { width: w, height: h } = image

    w = width
    h = height
    context.filter = value
    context.drawImage(image, 0, 0, w, h)
    context.filter = 'none'
  }
})

export default button => {
  onClick.listen(button)
}